// extracted by mini-css-extract-plugin
module.exports = {"root":"Description_root__2J8jS","image":"Description_image__1YCLS","info":"Description_info__2kcnP","productName":"Description_productName__3g7eA"};